export const as_clnt = window.location.pathname.startsWith("/mall/core") || window.location.hostname === "b2bmall.corealpine.kr"
  ? "20000"
  : "10000";
//  10000 안나푸르나
//  20000 코어알파인

export const hostname = window.location.hostname;
export const isTest = false;
